<template>
  <div id="app">
    <router-view></router-view>
    <navbar/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
export default {
  name: 'app',
  components: { Navbar },
  data () {
    return {
      res: {},
      pathUrl:''
    };
  },
  created () {
    this.getUpdateSettings()

    let isPC = this.getScreen()
    if (!isPC) {
      window.location.href = 'https://shop.crcchc.com/yd/#/';
    }
    this.pathUrl = this.$route.name
  },
  mounted () {

    // 本地加载请求静态json文件的形式
    // this.axios.get('/json/user/login.json').then((res) => {
    //   this.res = res;
    // })
    // 通过easy-mock平台实现mock
    // 将axios中axios.defaults.baseURL = ''地址换为easy-mock项目地址
    // this.axios.get('/user/login').then((res) => {
    //   this.res = res;
    // })
    // 通过mockjs实现mock
    // this.axios.get('/user/login').then((res) => {
    //   this.res = res;
    // })
    if (this.$cookie.get('userId')) {
      this.getUserInfo();
      this.getCartSum();
    }
  },
  methods: {
    getUpdateSettings(){
			this.$api.mall.getUpdateSettings().then((res) => {
				if (res.code == 200) {
					if(res.data){
						this.$router.push({
              path:'/guide',
              query:{type:2}
            })
					}
				}
			})
		},
    getScreen () {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      ) {
        console.log("手机端");
        return false
      } else {
        console.log("pc端");
        return true
      }
    },
  }
};
</script>

<style lang="scss" scoped>
// @import '@/assets/scss/index.scss'; // 引入重置样式表（覆盖浏览器用户代理样式）
// @import '@/assets/scss/modal.scss'; // 引入模态框样式表
</style>
